/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';

// initial state
const state = {
  connections: null,
  duration: null,
  loaders: {
    connections: false,
  },
};

// getters
const getters = {
  duration: (state) => state.duration,
  connections: (state) => state.connections,
  loaders: (state) => state.loaders,
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },

  /**
   * Loads Fuel Funds and associated metrics
   */
  getConnections({ commit }) {
    commit('TOGGLE_LOADING', { key: 'connections', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/connections/getConnections/`)
      .then((response) => {
        commit('SET_PROPERTY', { key: 'duration', value: response.data.duration });
        commit('SET_PROPERTY', { key: 'connections', value: response.data.connections });
        commit('TOGGLE_LOADING', { key: 'connections', value: false });
      }).catch((err) => {
        this.handleErrorResponse(err);
      });
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
